import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import { NavigateNext as NavigateNextIcon, Home as HomeIcon } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import menuService from '../services/menuService';

const Breadcrumb = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const currentUser = authService.getCurrentUser();
    const userType = authService.getUserType();

    if (!currentUser || !userType) {
        return null;
    }

    const breadcrumbItems = menuService.getBreadcrumb(location.pathname, userType);

    if (breadcrumbItems.length === 0) {
        return null;
    }

    return (
        <Box sx={{ mb: 2 }}>
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
                sx={{
                    '& .MuiBreadcrumbs-separator': {
                        color: 'text.secondary',
                    },
                }}
            >
                {breadcrumbItems.map((item, index) => {
                    const isLast = index === breadcrumbItems.length - 1;
                    const isHome = item.path.endsWith('/dashboard');

                    if (isLast) {
                        return (
                            <Typography
                                key={item.path}
                                color="text.primary"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontWeight: 'medium',
                                }}
                            >
                                {isHome && <HomeIcon sx={{ mr: 0.5, fontSize: '1rem' }} />}
                                {item.text}
                            </Typography>
                        );
                    }

                    return (
                        <Link
                            key={item.path}
                            color="inherit"
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(item.path);
                            }}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                textDecoration: 'none',
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            {isHome && <HomeIcon sx={{ mr: 0.5, fontSize: '1rem' }} />}
                            {item.text}
                        </Link>
                    );
                })}
            </Breadcrumbs>
        </Box>
    );
};

export default Breadcrumb; 